
import { getInstituteAddressService } from '../services/applicationFormService'

export const getInstituteAddress = (value) => dispatch => {

    dispatch({
        payload: [],
        type: 'GET_INSTITUTE_ADDRESS_PENDING'
    })
    getInstituteAddressService(value).then((res) => {
        dispatch({
            payload: {
                data: res
            },
            type: 'GET_INSTITUTE_ADDRESS_SUCCESS'
        })
    }).catch((err) => {
        dispatch({
            payload: {
                data: {
                    data: []
                },
                error: err
            },
            type: 'GET_INSTITUTE_ADDRESS_ERROR'
        })
    })

}